<template>
  <div v-if="initialized">
    <div id="app">
      <router-view></router-view>
    </div>

    <b-modal centered v-model="alertshown" class="alertbox" ref="modalalert" id="modalalert" v-bind:hide-footer="true" v-bind:hide-header="true">
      <div class="modal-header">
          <div class="modal-title">
              <h5>{{$t('ATTENTION')}}</h5>
          </div>
          <button type="button" aria-label="Close" v-on:click="alertshown = false" class="close"><img src="../assets/img/icon-close.svg"></button>
      </div>
      <div class="d-block mt-2 modal-content-inside">
        <p class="center">{{modaltext}}</p>
      </div>
      <div class="text-center mb-lg">
          <b-btn class="mr-2 btn-bis btn-cancel" v-on:click="alertshown = false">{{$t('NO')}}</b-btn>
          <b-btn class="btn-bis btn-delete" v-on:click="positiveModalFunc">{{$t('YES')}}</b-btn>
      </div>
    </b-modal>


    <div id="myDiv" style="display: none;">
      {{$t('SELECTDATE')}}
      {{$t('SELECTTIME')}}
      {{$t('SELECTDATE')}}
      {{$t('LISTOFJOBS')}}
    </div>
  </div>
  <div v-else-if="!initialized" class="loading-page">
    <icon icon="spinner" scale="2" spin></icon>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import globals from '@/api/Globals'

export default {
  name: 'app',
  data: function()
  {
    return {alertshown: false, positivefunc: function(){}, modaltext: ''}
  },
  components:
  {

  },
  methods:
  {
    ...mapActions([
      'getGlobals',
      'fetchLanguage',
    ]),
    positiveModalFunc: function()
    {
      var me = this;
      me.positivefunc();
      me.alertshown = false;
      me.positivefunc = function(){};
    }
  },
  created: function()
  {
    this.getGlobals();
  },
  watch:
  {
    'globals.groupId': function(value)
    {
      const me = this;
      if (value === 0 || value === 2)
      {
          this.$router.push('/login/');
      }
      else
      {
          if (me.globals.acl.Dashboard && me.globals.acl.Dashboard.instantiate)
          {
            this.$router.push('/dashboard')
          }
          else
          {
            this.$router.push('/job');
          }
      }
      /* if(value != 0 && value != 2)
      {
          if (value == 8)
          {
            this.$router.push('/job')
          }
          else
          {
            this.$router.push('/dashboard')
          }
      }
      else
      {
          this.$router.push('/login')
      } */
    },
    'globals.langId': function(value)
    {
      this.fetchLanguage(value);
    },
    translation: function(value)
    {
      this.$i18n.setLocaleMessage('ln'+value.key, value.root)
      this.$i18n.locale = 'ln'+value.key
    },
    langInitialized: function(value)
    {
      if(value)
      {
        this.$i18n.missing = function(handler, key, vueInst)
        {
          globals.checkTrans(key)
        }
      }
    },
    modalAlert: function(val)
    {
      var me = this;
      me.alertshown = true;
      me.modaltext = val.text;
      me.positivefunc = val.btnAction;
    }
  },
  computed:
  {
    ...mapGetters([
      'globals',
      'modalAlert',
      'translation',
      'langInitialized'
    ]),
    loggedIn: function()
    {
      return (this.globals.groupId != 2) ? true : false;
    },
    initialized: function()
    {
      return (this.globals.groupId != 0) ? true : false;
    }
  }
}
</script>
